import { combineReducers } from 'redux';
import * as _ from 'lodash';
import { list } from './list/list.reducer';
import { create } from './create/create.reducer';
import { edit } from './edit/edit.reducer';
import {GET_ALL_DELIVERY_TIMINGS_REQUESTED, GET_ALL_DELIVERY_TIMINGS_SUCCEEDED} from "./delivery.actions";
export const Delivery = combineReducers({
  list, create, edit, DeliveryTiming: (state = { fetched: false, items: [] }, action) => {
    switch (action.type) {
      case GET_ALL_DELIVERY_TIMINGS_REQUESTED:
        return _.assign({}, state, {
          fetched: false
        });
      case GET_ALL_DELIVERY_TIMINGS_SUCCEEDED:
        return _.assign({}, state, {
          fetched: true,
          items: action.data
        });
      default:
        return state;
    }
  }
});
